import { ReactNode } from "react";
import { LuEyeClosed } from "react-icons/lu";
import { LuEye } from "react-icons/lu";
import List from "./common/List";

interface Props {
  label: string | ReactNode;
  isHide: boolean;
  value: string;
  labelClassName?: string;
  handleToggleHide: () => void;
}

const maskCode = (code: string) => code.replace(/./g, "*");

const KeyInfoItem = ({ label, isHide, value, labelClassName, handleToggleHide }: Props) => {
  return (
    <List.Item
      strong
      label={label}
      labelClassName={labelClassName}
      valueClassName="flex justify-between items-center"
      value={
        <>
          {isHide ? maskCode(value) : value}
          <button type="button" onClick={handleToggleHide}>
            {isHide ? <LuEye size={22} /> : <LuEyeClosed size={22} />}
          </button>
        </>
      }
    />
  );
};

export default KeyInfoItem;
